import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-caption" }
const _hoisted_2 = {
  key: 0,
  class: "loader-wrap"
}

import { ref, computed, shallowRef } from "vue";
import { useSystemStore } from "./store/system-store";
import { useUserStore } from "./store/user-store";
import router from "./router";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const systemStore = useSystemStore();
const userStore = useUserStore();

const drawer = ref(false);
const tab = ref(null);
const tabList = ref([
  {
    tabName: "HOME",
    icon: "mdi-home-variant-outline",
    tabPath: "/",
    requireAuth: false,
    bottom: true,
  },
  {
    tabName: "NEWS",
    icon: "mdi-newspaper-variant-outline",
    tabPath: "news",
    requireAuth: false,
    bottom: true,
  },
  {
    tabName: "MARKET",
    icon: "mdi-chart-line",
    tabPath: "market",
    requireAuth: false,
    bottom: true,
  },
  {
    tabName: "LOG",
    icon: "mdi-file-document-multiple-outline",
    tabPath: "log",
    requireAuth: true,
    bottom: false,
  },
  {
    tabName: "JOB",
    icon: "mdi-calendar-check-outline",
    tabPath: "job",
    requireAuth: true,
    bottom: false,
  },
  {
    tabName: "CHART",
    icon: "mdi-calendar-check-outline",
    tabPath: "plotlychart",
    requireAuth: true,
    bottom: false,
  },
  {
    tabName: "SIM",
    icon: "mdi-chart-box-plus-outline",
    tabPath: "simulation",
    requireAuth: false,
    bottom: true,
  },
]);

const enableTabList = computed(() => {
  return tabList.value.filter((tab) => {
    return !tab.requireAuth || (tab.requireAuth && userStore.isLoggedIn);
  });
});

const bottomeTabList = computed(() => {
  return tabList.value.filter((tab) => {
    return (
      tab.bottom &&
      (!tab.requireAuth || (tab.requireAuth && userStore.isLoggedIn))
    );
  });
});

const moveTo = async (to: string) => {
  router.replace(to);
};

const open = shallowRef(false);

const refresh = () => {
  router.go(0);
};

return (_ctx: any,_cache: any) => {
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list_item_group = _resolveComponent("v-list-item-group")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_bottom_navigation = _resolveComponent("v-bottom-navigation")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createElementVNode("header", null, [
        _createVNode(_component_v_app_bar, {
          app: "",
          dark: "",
          density: "compact"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_app_bar_nav_icon, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (drawer.value = true))
            }),
            _createVNode(_component_v_toolbar_title, null, {
              default: _withCtx(() => [
                _cache[8] || (_cache[8] = _createTextVNode("CAGE ")),
                _createElementVNode("span", _hoisted_1, "- " + _toDisplayString(_unref(router).currentRoute.value.name) + " -", 1)
              ]),
              _: 1
            }),
            (_unref(userStore).notificationPermit === 'default')
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 0,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(userStore).confirmAllowNotification()))
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createTextVNode(" 通知を許可 ")
                  ])),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!_unref(userStore).isLoggedIn)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 1,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(userStore).login())),
                  "prepend-icon": "mdi-login"
                }))
              : _createCommentVNode("", true),
            (_unref(userStore).isLoggedIn)
              ? (_openBlock(), _createBlock(_component_v_btn, {
                  key: 2,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(userStore).logout())),
                  "prepend-icon": "mdi-logout"
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_navigation_drawer, {
          modelValue: drawer.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((drawer).value = $event)),
          fixed: "",
          temporary: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_list, {
              nav: "",
              dense: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_group, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(enableTabList.value, (tab) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: tab.tabName,
                        value: tab.tabName,
                        onClick: ($event: any) => (moveTo(tab.tabPath)),
                        "prepend-icon": tab.icon
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tab.tabName), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["value", "onClick", "prepend-icon"]))
                    }), 128)),
                    (!_unref(userStore).isLoggedIn)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 0,
                          value: "LOGIN",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(userStore).login())),
                          "prepend-icon": "mdi-login"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[10] || (_cache[10] = [
                                _createTextVNode("LOGIN")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_unref(userStore).isLoggedIn)
                      ? (_openBlock(), _createBlock(_component_v_list_item, {
                          key: 1,
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_unref(userStore).logout())),
                          "prepend-icon": "mdi-logout"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => _cache[11] || (_cache[11] = [
                                _createTextVNode("LOGOUT")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          _createVNode(_component_router_view)
        ]),
        _: 1
      }),
      (_unref(systemStore).isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[12] || (_cache[12] = _createElementVNode("div", { class: "loader" }, "loading", -1)),
            _createTextVNode(" " + _toDisplayString(!_ctx.$vuetify.display.mdAndUp ? "" : "REFRESH"), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("footer", null, [
        _createVNode(_component_v_bottom_navigation, { density: "compact" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn, {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (refresh()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createTextVNode("mdi-refresh")
                  ])),
                  _: 1
                }),
                _cache[14] || (_cache[14] = _createTextVNode(" REFRESH "))
              ]),
              _: 1
            }),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bottomeTabList.value, (tab) => {
              return (_openBlock(), _createBlock(_component_v_btn, {
                key: tab.tabName,
                value: tab.tabName,
                onClick: ($event: any) => (moveTo(tab.tabPath))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tab.icon), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createTextVNode(" " + _toDisplayString(tab.tabName), 1)
                ]),
                _: 2
              }, 1032, ["value", "onClick"]))
            }), 128))
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }))
}
}

})